<template>
  <section class="register container centered fill-vertical">
    <card title="Create Account" classes="narrow">
      <form v-on:submit.prevent="register" class="form">
        <div v-if="sending">
          Sending registration...
        </div>
        <div v-else-if="success" class="note form-confirmation">
          You have been registered as <span class="username">{{user.username}}</span>.
          Please check your email at <span class="email">{{user.email}}</span> to confirm your registration.
        </div>
        <div v-else class="flex column">
          <div class="content-description">Create account to keep a permanent score and submit your own photo challenges for others to play.</div>
          <label>Email</label>
          <input type="text" id="email" autofocus />
          <label>Username</label>
          <input type="text" id="username" />
          <label>Password</label>
          <input type="password" id="password" />
          <button type="submit">Register</button>
          <div v-if="error" class="form-error">
            {{ error }}
          </div>
        </div>
      </form>
    </card>
  </section>
</template>

<script>
  import Card from  "~/components/Card";
  import './register.scss';

  export default {
    data() {
      return {
        sending: false, 
        success: false,
        error: undefined
      };
    },
    components: {
      Card
    },
    methods: {
      register() {
        this.sending = true;
        this.error = undefined;
        this.success = false;

        this.$pqapi.register({
          username: document.getElementById('username').value,
          email: document.getElementById('email').value,
          password: document.getElementById('password').value
        })
        .then(response => {
          this.sending = false;
          if (!response) return;

          if (response.message) {
            const message = response.message.map(m => m.messages.map(m2 => m2.message).join('\n')).join('\n');

            this.error = message;
          } else {
            this.success = true;
            this.user = response.user;
          }
        });
      }
    }
  }
</script>
